"use client";
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import NextLink from "next/link";
import { useTranslation } from "react-i18next";

const ZaynCtaBannerSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        py: { xs: 1, sm: 1, md: 1 },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "24px",
            backgroundColor: "#14122B", // image load hone tak fallback
            backgroundImage:
              "url(https://getgeek-website-assets.b-cdn.net/BGZaynCtaBannerSection.webp)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            px: { xs: 3, sm: 5, md: 8 },
            py: { xs: 5, sm: 6, md: 7 },
            textAlign: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              position: "relative",
              zIndex: 1,
              fontSize: { xs: "22px", sm: "26px", md: "38px" },
              fontWeight: 700,
              lineHeight: 1.35,
              color: "#FFFFFF",
              fontFamily: "var(--font-plusjakarta)",
              maxWidth: 600,
              mx: "auto",
              mb: { xs: 2, sm: 2.5 },
            }}
          >
            {t("zaynCtaBanner.heading")}
          </Typography>

          <Typography
            sx={{
              position: "relative",
              zIndex: 1,
              fontSize: { xs: "13px", sm: "14px" },
              color: "#B8B8CC",
              lineHeight: 1.7,
              fontWeight: 400,
              fontFamily: "var(--font-outfit)",
              maxWidth: 620,
              mx: "auto",
              mb: { xs: 3, sm: 3.5 },
            }}
          >
            {t("zaynCtaBanner.description")}
          </Typography>

          <NextLink
            href="/free-trial-of-ai-recruiting-tool"
            passHref
            legacyBehavior
          >
            <Button
              component="a"
              sx={{
                position: "relative",
                zIndex: 1,
                bgcolor: "#7A2BF5",
                color: "#fff",
                px: { xs: 3.5, sm: 4 },
                py: { xs: 1.2, sm: 1.4 },
                borderRadius: "50px",
                textTransform: "none",
                fontSize: { xs: "14px", sm: "15px" },
                fontWeight: 500,
                fontFamily: "var(--font-outfit)",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "#5F1FC7",
                  transform: "scale(1.03)",
                },
              }}
            >
              {t("zaynCtaBanner.cta")}
            </Button>
          </NextLink>
        </Box>
      </Container>
    </Box>
  );
};

export default ZaynCtaBannerSection;